import React, { useState } from 'react'
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1'
import { Button, CheckBox, Icon } from '@st-operations/uikit/src/v2'

const MediaMeasurementCampaignSubmittedModal = ({ open, onConfirm }) => {
  const [emailNotification, setEmailNotificaiton] = useState(true)

  return (
    <Dialog open={open} close={close}>
      <div className="flex flex-col items-center px-16 py-8 pb-4">
        <h2 className="text-primary font-semibold text-5xl">Campaign Submitted!</h2>
        <p>
          {"You've finished Step 1. Please wait "}
          <span className="font-semibold text-primary">1 hour</span>
          {' for the system finding URLs'}
        </p>
        <ul className="mt-6 flex flex-row items-center gap-8 list-none">
          <li className="flex flex-col gap-1 items-center justify-end text-primary">
            <Icon type="outline" icon="checkall" width={100} height={100} />
            <span className="font-semibold">Submit Campaign</span>
          </li>
          <Icon type="outline" icon="angleright" width={32} height={32} />
          <li className="flex flex-col gap-1 items-center text-gray-600">
            <Icon type="outline" icon="search" width={100} height={100} />
            <span className="font-semibold">Finding URLs</span>
          </li>
          <Icon type="outline" icon="angleright" width={32} height={32} />
          <li className="flex flex-col gap-1 items-center text-gray-600">
            <Icon type="outline" icon="downloadcloud" width={100} height={100} />
            <span className="font-semibold text-center">
              Delivering to <br />
              StatSocial
            </span>
          </li>
        </ul>
        <div className="flex flex-row items-center gap-4">
          <CheckBox
            checked={emailNotification}
            onChange={(e) => setEmailNotificaiton(e.target.checked)}
          />{' '}
          <span>Get Email notification when processed</span>
        </div>
        <Button className="mt-16" onClick={() => onConfirm(emailNotification)}>
          Got it
        </Button>
      </div>
    </Dialog>
  )
}

export default MediaMeasurementCampaignSubmittedModal
